webpackJsonp([7],{

/***/ 1024:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af540c1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSectionDialog_vue__ = __webpack_require__(1027);
function injectStyle (ssrContext) {
  __webpack_require__(1025)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af540c1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSectionDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af540c1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSectionDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1026);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("22a2ebf3", content, true, {});

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".button-containers[data-v-af540c1a]{display:flex;flex-wrap:wrap;flex-direction:row-reverse;margin-top:-8px}.left-side-button[data-v-af540c1a]{display:flex;flex-direction:row-reverse;margin-top:8px}.right-side-button[data-v-af540c1a]{flex-grow:1;text-align:right}.danger-button[data-v-af540c1a],.hide-btn-container[data-v-af540c1a]{margin-left:.5em}.right-side-button>button[data-v-af540c1a]{margin-top:8px}@media (max-width:650px){.button-containers[data-v-af540c1a]{display:block;text-align:center}.left-side-button[data-v-af540c1a]{display:block}.right-side-button[data-v-af540c1a]{text-align:center}.danger-button[data-v-af540c1a]{margin-left:0;margin-bottom:8px}}.edit-object-title[data-v-af540c1a]:before{content:\" - \"}", ""]);

// exports


/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"isInline":_vm.isInline,"isInlinePin":_vm.isInlinePin},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{ref:"dialogContainer",staticClass:"field-of-fields",class:_vm.isInline || _vm.isInlinePin ? '' : 'p-5',attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(!_vm.isInline && !_vm.isInlinePin)?_c('div',[(_vm.title)?_c('h3',{staticClass:"dialog-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]):(_vm.isAdd)?_c('EditLabelSetting',{attrs:{"title":"Edit Heading","modelKey":_vm.getCustomizableLabelModelKey('add_item_header'),"defaultValue":_vm.getLabelByKeys('LABELS.ADD_ITEM', _vm.headerSingularForm),"classList":"dialog-title","tagName":"h3"}},[(_vm.isAgent && _vm.field && _vm.field.sectionBuilderId)?_c('i',{staticClass:"material-icons edit-builder-icon ml-2",attrs:{"slot":"after-label"},on:{"click":function($event){return _vm.$emit('setting')}},slot:"after-label"},[_vm._v("\n          settings\n        ")]):_vm._e()]):(!_vm.isAdd)?_c('EditLabelSetting',{attrs:{"title":"Edit Heading","modelKey":_vm.getCustomizableLabelModelKey('edit_item_header'),"defaultValue":_vm.getLabelByKeys('LABELS.EDIT_ITEM', _vm.headerSingularForm),"classList":"dialog-title","tagName":"h3"}},[(_vm.getObjectTitle())?_c('h3',{staticClass:"edit-object-title",attrs:{"slot":"after-label"},slot:"after-label"},[_vm._v("\n          "+_vm._s(_vm.getObjectTitle())+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.isAgent && _vm.field && _vm.field.sectionBuilderId)?_c('i',{staticClass:"material-icons edit-builder-icon ml-2",attrs:{"slot":"after-label2"},on:{"click":function($event){return _vm.$emit('setting')}},slot:"after-label2"},[_vm._v("\n          settings\n        ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}})],1):_vm._e(),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"submitClicked":_vm.submitClicked,"modelData":_vm.userInputData,"listFields":_vm.listVisibleFields,"submitInfo":_vm.submitInfo,"hasFileAccessControlBtn":false}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-containers"},[_c('div',{staticClass:"right-side-button"},[_c('button',{staticClass:"submit-button mylisting-button dark-button",on:{"click":function($event){return _vm.handleClickSaveButton()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.SAVE"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-inline-block"},[(_vm.isAdd)?_c('EditButtonSetting',{attrs:{"modelKey":_vm.getCustomizableButtonModelKey('add_and_save'),"defaultValue":_vm.getLabelByKeys(
                'LABELS.SAVE_AND_ADD_ANOTHER_ITEM',
                _vm.headerSingularForm
              ),"classList":"submit-button mylisting-button secondary-button"},on:{"click":function($event){return _vm.handleClickSaveButton(true)}}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"left-side-button"},[_c('div',{staticClass:"delete-btn-container"},[(!_vm.hideDeleteBtn && !_vm.isAdd)?_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.showDeleteDataConfirmDialog()}}},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("BUTTONS.DELETE"))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cancel-button-container"},[_c('button',{staticClass:"mylisting-button secondary-button cancel-button",on:{"click":function($event){return _vm.handleClickCancelButton()}}},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("BUTTONS.CANCEL"))+"\n          ")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.field.hideSectionTitle)?_c('h3',{staticClass:"mt-4 d-flex"},[_vm._v("\n    "+_vm._s(_vm.sectionTitle)+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.field.hideSectionTitle)?_c('hr',{staticStyle:{"margin":"0"}}):_vm._e(),_vm._v(" "),(_vm.description && _vm.description !== '')?_c('div',{staticClass:"description mt-2"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('EditButtonSetting',{attrs:{"modelKey":_vm.buttonModelKey,"defaultValue":((_vm.getLabelByKeys('BUTTONS.ADD')) + " " + (_vm.convertToSingularForm(
      _vm.header
    ))),"classList":"mylisting-button dark-button mt-3 mb-3"},on:{"click":function($event){return _vm.showAddObjectDialog()}}}),_vm._v(" "),(_vm.field.downloadFileURL)?_c('button',{staticClass:"mylisting-button secondary-button mt-3 mb-3",on:{"click":function($event){return _vm.downloadFile(
        _vm.field.downloadFileURL,
        _vm.field.downloadFileText
          ? _vm.field.downloadFileText
          : 'Download Reference Check File'
      )}}},[_vm._v("\n    "+_vm._s(_vm.field.downloadFileText
        ? _vm.field.downloadFileText
        : "Download Reference Check File")+"\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.data),function(object,index){return _c('div',{key:'ref' + index},[_c('hr',{staticClass:"ref-separator"}),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"600","margin-bottom":"0"}},[_vm._v("\n      "+_vm._s(_vm.getObjectTitle(object))+"\n      "),_c('span',{staticClass:"edit-button",on:{"click":function($event){return _vm.showEditObjectDialog(object, index)}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" edit ")])])]),_vm._v(" "),_c('DetailSectionRowLayout',{attrs:{"modelData":object,"listFields":_vm.listFieldsNormalized,"listExcludeFields":_vm.keyTitles}})],1)}),_vm._v(" "),(
      _vm.minCount &&
      _vm.data.length < _vm.minCount &&
      (_vm.submitClicked || _vm.showMinEntriesRequiredApplicationForm)
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n  You need at least "+_vm._s(_vm.minCount)+" "+_vm._s(_vm.minCount === 1? _vm.convertToSingularForm(_vm.header): _vm.header)+"!\n  ")]):_vm._e(),_vm._v(" "),_c('ProfileSectionDialog',{attrs:{"name":_vm.name,"header":_vm.header,"listFields":_vm.listFieldsNormalized,"keyTitles":_vm.keyTitles,"data":_vm.object,"field":_vm.field,"profileBuilderID":_vm.profileBuilderID,"isAdd":_vm.isAddObjectDialog,"submitInfo":_vm.fileSubmitInfo},on:{"saved":function($event){return _vm.handleUpdateObjects($event)}},model:{value:(_vm.isShowObjectFormDialog),callback:function ($$v) {_vm.isShowObjectFormDialog=$$v},expression:"isShowObjectFormDialog"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 895:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f47b7bb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationSectionWithDialog_vue__ = __webpack_require__(1028);
function injectStyle (ssrContext) {
  __webpack_require__(998)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f47b7bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationSectionWithDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f47b7bb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationSectionWithDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _DetailSectionRowLayout = __webpack_require__(278);

var _DetailSectionRowLayout2 = _interopRequireDefault(_DetailSectionRowLayout);

var _ProfileSectionDialog = __webpack_require__(1024);

var _ProfileSectionDialog2 = _interopRequireDefault(_ProfileSectionDialog);

var _customDefineType = __webpack_require__(6);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * The component is used to show for the section like reference or experience or education
 * in the application form
 */
exports.default = {
  props: {
    header: String,
    sectionTitle: String,
    // Description which are only visible to admin
    adminDescription: String,
    description: String,
    name: String,
    listFields: Array,
    keyTitles: {
      type: Array,
      default: function _default() {
        return ["name"];
      }
    },
    // List models which is only showed when access from admin account
    listModelsAdminOnly: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // List models which is only visible for admin and client
    listModelsAdminClient: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    data: Array,
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Minimum number of item
    minCount: Number,
    field: {
      type: Object,
      default: function _default() {}
    },
    profileBuilderID: Number,
    applicationData: {
      type: Object,
      default: function _default() {}
    }
  },
  components: {
    DetailSectionRowLayout: _DetailSectionRowLayout2.default,
    ProfileSectionDialog: _ProfileSectionDialog2.default
  },
  data: function data() {
    return {
      isShowObjectFormDialog: false,
      object: {},
      isAddObjectDialog: false,
      indexOfEdittingObject: 0,
      isShowSectionBuilderUpSertDialog: false
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["language", "showMinEntriesRequiredApplicationForm", "isAgent"]), {
    buttonModelKey: function buttonModelKey() {
      return "section_" + this.profileBuilderID + "_" + (this.field ? this.field.sectionBuilderId : "") + "_add_text_" + (this.language || "");
    },
    listFieldsNormalized: function listFieldsNormalized() {
      var _this = this;

      var listExcludeModels = [].concat(_toConsumableArray(this.listModelsAdminOnly), _toConsumableArray(this.listModelsAdminClient));
      var result = this.listFields.filter(function (field) {
        return !field.notInApplication && !listExcludeModels.includes(field.model);
      });
      // Check show condition of people fields
      if (this.applicationData) {
        result = result.filter(function (field) {
          if (!field.showIf) {
            return true;
          }
          if (field.showIf.indexOf("people_") === 0) {
            return _this.isItemShow(_this.applicationData, _extends({}, field, { showIf: field.showIf.replace("people_", "") }), []);
          }
          return true;
        });
        result = this.cloneArrayOfObject(result);
        result.forEach(function (field) {
          if (field.showIf && field.showIf.indexOf("people_") === 0) {
            field.showIf = null;
          }
        });
      }
      return result;
    },
    listShareModelFields: function listShareModelFields() {
      return this.listFieldsNormalized.filter(function (field) {
        return field.isShareModel;
      });
    },
    fileSubmitInfo: function fileSubmitInfo() {
      if (this.profileBuilderID) {
        return {
          profileBuilder: this.profileBuilderID,
          email: this.applicationData ? this.applicationData.email : null
        };
      }
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["reloadProfileBuilderList"]), {
    getObjectTitle: function getObjectTitle(object) {
      return this.keyTitles.map(function (title) {
        return object[title];
      }).join(" ");
    },
    showAddObjectDialog: function showAddObjectDialog() {
      var _this2 = this;

      this.isAddObjectDialog = true;
      this.object = {
        section_builder_id: this.field ? this.field.sectionBuilderId : null,
        profile_builder_id: this.profileBuilderID
      };
      this.listShareModelFields.forEach(function (field) {
        _this2.object[field.model] = [];
        _this2.object[field.model][field.shareModelIndex] = "";
      });
      this.isShowObjectFormDialog = true;
    },
    showEditObjectDialog: function showEditObjectDialog(ref, index) {
      this.indexOfEdittingObject = index;
      this.isAddObjectDialog = false;
      this.object = _extends({}, ref, {
        section_builder_id: this.field ? this.field.sectionBuilderId : null,
        profile_builder_id: this.profileBuilderID
      });
      this.isShowObjectFormDialog = true;
    },
    handleUpdateObjects: function handleUpdateObjects(_ref) {
      var type = _ref.type,
          data = _ref.data;

      if (type === _customDefineType.ACTION_TYPE.ADD) {
        this.data.push(_extends({}, data, { id: 0 }));
      } else if (type === _customDefineType.ACTION_TYPE.UPDATE) {
        this.data[this.indexOfEdittingObject] = data;
      } else if (type === _customDefineType.ACTION_TYPE.DELETE) {
        this.data.splice(this.indexOfEdittingObject, 1);
      }
    },
    handleShowBuilderSetting: function handleShowBuilderSetting() {
      this.isShowSectionBuilderUpSertDialog = true;
    }
  })
};

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
This component is used for a dialog (add/edit) objects (reference/children/experience/education...)
 */


var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ProfileSectionDialog",
  props: {
    header: String,
    name: String,
    user: Object,
    data: Object,
    title: String,
    keyTitles: {
      type: Array,
      default: function _default() {
        return ["name"];
      }
    },
    value: Boolean,
    isAdd: Boolean,
    listFields: Array,
    isSendRequest: {
      type: Boolean,
      default: false
    },
    api: String,
    /* Title and message of dialog when save successfully */
    submissionContent: Object,
    // List models which is not showed
    listExcludeFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // The corresponding field of profile builder
    field: {
      type: Object,
      default: function _default() {}
    },
    // ID of profile builder
    profileBuilderID: Number,
    hideDeleteBtn: {
      type: Boolean,
      default: false
    },
    submitInfo: Object,
    isInline: {
      type: Boolean,
      default: false
    },
    isInlinePin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ModalDialog: _ModalDialog2.default
  },
  data: function data() {
    return {
      submitClicked: false,
      ACTION_TYPE: _customDefineType.ACTION_TYPE,
      isShow: false,
      userInputData: {},
      hideAllField: false // Variable to reset listVisibleField
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["listExperienceTypes", "language", "isAgent"]), {
    accessControlObj: function accessControlObj() {
      return {
        title: "Access Control",
        listFields: [{
          label: "Please select access level scope for this file",
          model: "accessScope",
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          optionList: [{
            label: "Private (Visible to admin and the owner)",
            model: "private"
          }, {
            label: "Public (Visible to everyone)",
            model: "public"
          }],
          optionLabel: "label",
          optionModel: "model"
        }]
      };
    },
    headerSingularForm: function headerSingularForm() {
      return this.convertToSingularForm(this.header);
    },
    listVisibleFields: function listVisibleFields() {
      var _this = this;

      if (this.hideAllField) {
        return [];
      }
      if (this.listFields == null) {
        return [];
      }
      if (this.name === "Experience" && this.listExperienceTypes && this.listExperienceTypes.length) {
        var typesField = this.listFields.find(function (field) {
          return field.model === "types";
        });
        if (typesField && !typesField.optionList) {
          typesField.optionList = this.listExperienceTypes;
        }
      }

      return this.listFields.filter(function (field) {
        return !_this.listExcludeFields.includes(field.model);
      });
    },
    isTypeInUsed: function isTypeInUsed() {
      if (!this.listFields) {
        return false;
      }
      return this.listFields.some(function (field) {
        return field.model === "type";
      });
    }
  }),
  methods: {
    hideModal: function hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal: function showModal() {
      this.isShow = true;
    },
    getCustomizableButtonModelKey: function getCustomizableButtonModelKey(key) {
      return "section_" + this.profileBuilderID + "_" + (this.field ? this.field.sectionBuilderId : "") + "_" + key + "_" + (this.language || "");
    },
    getCustomizableLabelModelKey: function getCustomizableLabelModelKey(key) {
      return "public_advance_setting.section_" + this.profileBuilderID + "_" + (this.field ? this.field.sectionBuilderId : "") + "_" + key + "_" + (this.language || "");
    },
    getObjectTitle: function getObjectTitle() {
      var _this2 = this;

      return this.keyTitles.map(function (titleKey) {
        return _this2.removeOtherRadioPrefix(_this2.userInputData[titleKey]);
      }).join(" ");
    },
    handleClickSaveButton: function handleClickSaveButton(addAnother) {
      var _this3 = this;

      var isContinue;
      return regeneratorRuntime.async(function handleClickSaveButton$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.userInputData.email) {
                this.userInputData.email = this.userInputData.email.trim();
              }
              if (this.userInputData.email2) {
                this.userInputData.email2 = this.userInputData.email2.trim();
              }
              this.submitClicked = true;
              // Check to show warning for missing fields
              _context.next = 5;
              return regeneratorRuntime.awrap(this.validateBaseInputValues(this.userInputData, this.listVisibleFields));

            case 5:
              isContinue = _context.sent;

              if (isContinue) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:

              console.log(this.userInputData);
              this.$emit("saved", {
                type: this.isAdd ? _customDefineType.ACTION_TYPE.ADD : _customDefineType.ACTION_TYPE.UPDATE,
                data: _extends({}, this.userInputData)
              });
              if (addAnother) {
                this.showResultDialog(_extends({}, this.$store.getters.saveAndAddNewObject, {
                  params: [this.name],
                  onCloseCallback: function onCloseCallback() {
                    _this3.hideAllField = true;
                    _this3.$nextTick(function () {
                      _this3.hideAllField = false;
                    });
                    _this3.submitClicked = false;
                    _this3.userInputData = _this3.getInitialObject();
                    _this3.$refs.dialogContainer.scrollIntoView();
                  }
                }));
              } else {
                this.hideModal();
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    handleClickCancelButton: function handleClickCancelButton() {
      if (this.isDisableConfirmCancellation()) {
        this.hideModal();
        return;
      }
      // Check if data is unchanged
      if (this.isUnchangedObject(this.data, this.userInputData, this.listVisibleFields)) {
        this.hideModal();
        return;
      }
      this.showConfirmDialog(_extends({}, this.$store.getters.cancelConfirmDialog, {
        onAcceptCallback: this.hideModal
      }));
    },
    showDeleteDataConfirmDialog: function showDeleteDataConfirmDialog() {
      this.showConfirmDialog(_extends({}, this.$store.getters["delete" + this.name + "ConfirmDialog"], {
        onAcceptCallback: this.deleteData
      }));
    },
    deleteData: function deleteData() {
      this.hideModal();
      this.$emit("saved", { type: _customDefineType.ACTION_TYPE.DELETE });
    },
    getInitialObject: function getInitialObject() {
      var result = {};
      if (!this.listFields) {
        return result;
      }
      var listShareModelFields = this.listFields.filter(function (field) {
        return field.isShareModel;
      });
      listShareModelFields.forEach(function (field) {
        result[field.model] = [];
        result[field.model][field.shareModelIndex] = "";
      });
      // Find list of fields with initial values
      var listInitialFields = this.listFields.filter(function (field) {
        return field.initialValue && field.model;
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = listInitialFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          result[field.model] = field.initialValue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        if (value === true) {
          this.submitClicked = false;
          if (this.data) {
            if (this.isAdd) {
              this.userInputData = this.getInitialObject();
            } else {
              this.userInputData = this.extractSelectedFields(this.data, this.listFields, true);
            }
          } else {
            this.userInputData = this.getInitialObject();
          }
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    },
    isShow: {
      immediate: true,
      handler: function handler() {
        this.$emit("input", this.isShow);
      }
    },
    data: {
      immediate: true,
      handler: function handler() {
        if (!this.isAdd && this.isInlinePin && this.listFields && this.listFields.length) {
          this.userInputData = this.extractSelectedFields(this.data, this.listFields, true);
        }
      }
    }
  }
};

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("edbfa696", content, true, {});

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".description[data-v-5f47b7bb]{font-size:80%;font-weight:400}", ""]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// 7.build.js